import React from "react";
import {
  getOrderStatusLabel,
  getOrderStatusTone,
} from "../../types/orders";
import "./OrderStatusTag.css";

interface OrderStatusTagProps {
  status: string;
}

/**
 * Status chip for sale.status_sale — same visual language as CatalogStatusTag.
 */
const OrderStatusTag: React.FC<OrderStatusTagProps> = ({ status }) => {
  const tone = getOrderStatusTone(status);
  return (
    <span className={`order-status-tag order-status-tag--${tone}`}>
      {getOrderStatusLabel(status)}
    </span>
  );
};

export default OrderStatusTag;
